function replaceUrlParam(url, paramName, paramValue) {
    //https://stackoverflow.com/a/49033367
    var href = new URL(url);
    href.searchParams.set(paramName, paramValue);
    return href.toString();

    //https://stackoverflow.com/a/20420424
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}


$('[data-table-orderable]').each(function (index, object) {
    var that = $(this);
    var columnName = that.data('table-orderable');
    var newUrlAsc = replaceUrlParam(window.location.href, 'ordering', that.data('table-orderable') + '%20asc');
    var newUrlDesc = replaceUrlParam(window.location.href, 'ordering', that.data('table-orderable') + '%20desc');

    var ordering = (new URL(window.location)).searchParams.get('ordering');
    var urlColumn, urlDirection;
    [urlColumn, urlDirection] = [];
    if (ordering) {
        ordering = decodeURI(ordering);
        [urlColumn, urlDirection] = ordering.split(' ');
    }

    if (index === 0 && !urlDirection) {
        urlColumn = columnName;
        urlDirection = 'asc';
    }
    that.children('div').append(`
            <span class="sorting-icons my-auto ps-1">
                <a href="${newUrlAsc}" class="d-inline ` + (columnName === urlColumn ? 'd-none' : null) + `"><i class="fas fa-sort"></i></a>
                <a href="${newUrlAsc}" class="d-inline ` + (urlColumn && columnName === urlColumn && urlDirection === 'desc' ? 'active' : 'd-none') + `"><i class="fas fa-sort-up"></i></a>
                <a href="${newUrlDesc}" class="d-inline ` + (urlColumn && columnName === urlColumn && urlDirection === 'asc' ? 'active' : 'd-none') + `"><i class="fas fa-sort-down"></i></a>
            </span>
        `);
    $(this).wrapInner('<div class="d-flex" />');
});